import api from "./api";

const getTransporter = async () => {

    const response = await api.get("/api/transporter");

    return response.data.data;

};

const addTransporter = async(formData)=>{
    const response = await api.post(
        "/api/transporter",
        formData
    );

    return response.data;

}

const updateTransporter = async(id,formData)=>{

    const response = await api.put(
        `/api/transporter/${id}`,
        formData
    );

    return response.data;

}

const deleteTransporter = async(id)=>{

    const response = await api.delete(`/api/transporter/${id}`);

    return response.data;

}

export default{
    getTransporter,
    addTransporter,
    updateTransporter,
    deleteTransporter
}